import { print } from 'graphql';
import { v4 as uuidv4 } from 'uuid';

import { ACTIVITY_UPDATE } from 'src/api/graphql/mutations/activity.gql';
import { graphqlUpload } from 'src/utils/helpers/graphqlUpload';
import { createGraphqlRequestError } from 'src/utils/helpers/getGraphqlErrorMessage';
import { materializeFileInputs } from 'src/utils/helpers/materializeFileInputs';

export const updateActivity = async (id, input) => {
	const idempotencyKey = uuidv4();
	const resolvedInput = await materializeFileInputs(input);
	const result = await graphqlUpload({
		query: print(ACTIVITY_UPDATE),
		variables: {
			id: String(id),
			idempotencyKey,
			input: resolvedInput,
		},
	});

	if (result.errors?.length) {
		throw createGraphqlRequestError(
			result.errors,
			'Не удалось изменить событие',
		);
	}

	return result.data.ActivityUpdate.activity;
};
